export default __webpack_public_path__ + "static/media/avatar-placeholder.ccf95717.svg";